<template>
    <div>
        <x-layout mb-3>
            <x-flex xs12>
                <x-select
                    v-model="selectedRiskCodes"
                    :items="riskCodes"
                    class="required"
                    label="Allocation of premium to coding"
                    placeholder=" "
                    :rules="[v => ruleMinSelected(v, 1, false, 'At least 1 risk code must be selected')]"
                    append-icon="keyboard_arrow_down"
                    item-value="id"
                    item-text="name"
                    required
                    multiple
                    :menu-props="{ offsetY: true }"
                />
            </x-flex>
        </x-layout>

        <template v-if="selectedRiskCodes.length > 0">
            <x-layout
                v-for="riskCodeValue in riskCodesValues"
                :key="riskCodeValue.risk_code_id"
                mb-3
            >
                <x-flex xs12>
                    <x-currency-text-field
                        v-model="riskCodeValue.value"
                        class="required"
                        :label="`${riskCodeValue.name} amount`"
                        placeholder=" "
                        suffix="%"
                        :rules="[
                            v => ruleRequired(v, `${riskCodeValue.name} amount`),
                            v => ruleNumeric(v, false, false, true),
                            v => ruleLessThanOrEqualTo(v, 100, `${riskCodeValue.name} amount`),
                            v => ruleGreaterThan(v, 0, `${riskCodeValue.name} amount`)
                        ]"
                    />
                </x-flex>
            </x-layout>
        </template>
    </div>
</template>

<script>
import rules from '~/mixins/rules';

export default {
    name: "AllocationOfPremiumQuestions",
    mixins: [rules],
    props: {
        submissionData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            riskCodes: [],
            selectedRiskCodes: [],
            riskCodesValues: [],
        }
    },
    mounted() {
        axios.get(this.$root.api('risk-codes')).then(res => {
            this.riskCodes = res.data.data;
            this.riskCodesValues = this.submissionData.risk_codes?.map(submissionRiskCode => ({
                ...submissionRiskCode,
                name: this.riskCodes.find(riskCode => riskCode.id == submissionRiskCode.risk_code_id)?.name || ''
            })) || [];
            this.selectedRiskCodes = this.submissionData.risk_codes?.map(submissionRiskCode => submissionRiskCode.risk_code_id) || [];
        });
    },
    watch: {
        selectedRiskCodes() {
            this.riskCodesValues = this.riskCodesValues.map(riskCodeValue => (
                {
                    ...riskCodeValue,
                    selected: false
                }
            ));
            this.selectedRiskCodes.forEach(selectedRiskCodeId => {
                const riskCodeValue = this.riskCodesValues.find(riskCodeValueObject => riskCodeValueObject.risk_code_id === selectedRiskCodeId);
                if (!riskCodeValue) {
                    return this.riskCodesValues.push({
                        risk_code_id: selectedRiskCodeId,
                        name: this.riskCodes.find(riskCode => riskCode.id === selectedRiskCodeId)?.name,
                        value: riskCodeValue?.value,
                        selected: true
                    });
                }

                riskCodeValue.selected = true;
            });

            this.riskCodesValues = this.riskCodesValues.filter(riskCodeValue => riskCodeValue.selected === true);
        },
        riskCodesValues: {
            deep: true,
            handler() {
                this.submissionData.risk_codes = this.riskCodesValues;
            }
        },
    }
}
</script>

<style>

</style>
